import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseRecoverSessionRepository } from '@/modules/auth/infra'
import type { RecoverSession } from '@/shared/domain'

export function makeRecoverSession(): RecoverSession {
  return new SupabaseRecoverSessionRepository(makeSupabaseClient()).execute
}
